<script setup lang="ts">
import { format } from 'date-fns'
import { extractURLFromNotification } from '~/utils/notifications'

// Why emit name is `send` instead of `onSend` ?? See below
// Ref: https://github.com/primefaces/primevue/issues/5674
// const emit = defineEmits<{
//   (e: 'send', payload: { userID: number, message: string }): void
//   (e: 'validationError', msg: string): void
//   (e: 'cancel'): void
// }>()
const dialogRef = inject<Ref<{ close: () => void }>>('dialogRef')
// const dialogRef = inject<Ref<{ data: { message: string, placeholder?: string, credits: number, userID: number }, close: () => void }>>('dialogRef')
// const message = ref('')
// const credits = ref<number>(0)
// const userID = ref<number>(0)

const layout = ref<'list' | 'grid'>('grid')
const notifStore = useNotificationStore()
const { actionOnNotification } = useNotificationStore()
const { userNotifications } = storeToRefs(notifStore)
const router = useRouter()
const toast = useToast()
const layoutList = ref<'list' | 'grid'>('list')

const goToBreadcrumb = async (item: CanxNotification) => {
  try {
    const url = extractURLFromNotification(item)
    await router.push(url)
  }
  catch (error) {
    toast.add({ severity: 'error', summary: 'Error', detail: `${(error as Error).message}`, life: 5000 })
  }
  finally {
    if (dialogRef) {
      dialogRef.value.close()
    }
  }
}
const markAsRead = async (item: CanxNotification) => {
  await actionOnNotification([item.id])
  item.status = NotificationStatusEnum.READ
}
const markaAllRead = async () => {
  await actionOnNotification([])
  userNotifications.value.forEach((item) => {
    if (item.status === NotificationStatusEnum.UNREAD) {
      item.status = NotificationStatusEnum.READ
    }
  })
  toast.add({ severity: 'success', summary: 'Success', detail: 'All notifications marked as read', life: 3000 })
}
// const onCancel = () => {
//   emit('cancel')
//   if (dialogRef) {
//     dialogRef.value.close()
//   }
// }

// const onSend = () => {
//   if (!message.value) {
//     emit('validationError', 'Message must not be empty')
//     return
//   }
//   emit('send', { userID: userID.value, message: message.value })
//   if (dialogRef) {
//     dialogRef.value.close()
//   }
// }

// onMounted(() => {
//   if (dialogRef) {
//     message.value = dialogRef.value.data.message
//     credits.value = dialogRef.value.data.credits
//     userID.value = dialogRef.value.data.userID
//   }
// })
</script>

<template>
  <DataView
    :pt-options="{ mergeProps: true }"
    :pt:root="{ class: 'overflow-y-auto' }"
    :value="userNotifications"
    :layout="layoutList"
    :data-key="layout"
    class=""
  >
    <template #header>
      <div class="flex justify-between text-primary-300 font-bold text-md">
        <div />
        <h1 class="flex-initial">
          Notifications
        </h1>
        <Button
          :pt-options="{ mergeProps: true }"
          :pt:root="{ class: 'text-xs flex-initial' }"
          size="small"
          @click="markaAllRead"
        >
          <template #icon>
            <i class="pi pi-check-square" />
          </template>
        </Button>
      </div>
    </template>

    <template #list="slotProps">
      <div class="flex flex-wrap">
        <div
          v-for="(item, index) in slotProps.items"
          :key="index"
          class="w-full hover:bg-surface-300"
          @click="() => markAsRead(item)"
        >
          <div
            class="flex flex-col sm:flex-row  p-2 gap-2"
            :class="{ ' border-t border-surface-200 dark:border-surface-700': index !== 0 }"
          >
            <div class="flex justify-between flex-1 gap-4 gap-2 ">
              <div class="w-full flex flex-col">
                <div
                  class="flex text-xs justify-between font-medium text-surface-900 dark:text-surface-0 "
                >
                  <div>
                    <span v-if="item.status==='UNREAD'"><i
                      v-badge.warning
                      class="relative top-2 left-0  mr-3 "
                    /></span>
                    {{ item.subject }}
                  </div>
                  <div class="place-items-end font-thin">
                    {{ format(item.date, 'dd-MM-yyyy hh:mm ') }}
                  </div>
                </div>
                <div class="flex flex-row flex-wrap text-xs justify-start text-surface-900 dark:text-surface-0 mt-2 ">
                  <div><span class="mr-1 font-medium">Prod:</span><span class=" mr-1"> {{ item.body.prod_name }} </span></div>
                  <div><span class="mr-1 font-medium">Qty:</span><span class=" mr-1 "> {{ item.body.prod_qty }} {{ item.body.prod_qty_type }} </span></div>
                  <div><span class="mr-1 font-medium">Price:</span><span class=""> {{ item.body.prod_price }}  {{ item.body.prod_price_cur }}</span></div>
                </div>
              </div>
              <div class="surface-0 flex items-center  justify-center ">
                <Button
                  icon="pi pi-eye"
                  class="w-4 h-4"
                  @click="goToBreadcrumb(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </DataView>
</template>

<style scoped>

</style>
